import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';
import $ from 'jquery';
import 'fullpage.js/dist/jquery.fullpage.js';

class Sandbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePageNum: 0
    }
  }

  setActivePage = (index) => {
    this.setState({
      activePageNum: index
    })
  }

  scrollTo = (chapter) => {
      console.log(chapter);
    $.fn.fullpage.moveTo(`${chapter}.0`);
  }

  render() {
    const { chapters, chapterIndex } = this.props;
    return (
      <div className="paginator">
        <ul>
        {
          chapters &&
          chapters.map((d, i) => {
            return (
              <li className={`item ${chapterIndex - 1 === i ? '-active' : ''}`} onClick={() => this.scrollTo(i+1)} key={i}>
                <span className="text">{chapterIndex - 1 === i  ? d.number : d.name}</span>
                <div className="line-wrap">
                  <div className="line"></div>
                </div>
              </li>
            )
          })
        }
        </ul>
      </div>
    );
  }
}

export default Sandbox;



// WEBPACK FOOTER //
// ./src/components/Paginator/pure.js